<template>
  <div id="BaseHomeContent">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-sm-12">
          <div class="row">
            <div class="col-sm-12">
              <div v-if="carouselAdsAreLoading === true">
                <loading-spinner />
              </div>
              <carousel
                v-if="carouselAdsAreLoading === false && carouselAds.length > 0"
                :carousel-ads="carouselAds"
              />
            </div>
            <div class="col-sm-12">
              <div class="news-home">
                <div class="row">
                  <div class="col-8">
                    <h2>{{ getContentItem("updatesAndNewsLabel") }}</h2>
                  </div>
                  <div class="col-4 all-news-link-wrapper">
                    <router-link to="/News" class="all-news-link">
                      {{ getContentItem("allNewsButton") }}
                    </router-link>
                  </div>
                </div>
                <ul v-if="newStoriesAreLoading === false && IsNotNullOrUndefined(newsStories, 'length') && newsStories.length > 0">
                  <li v-for="story in newsStories" :key="story.HeadingText">
                    <news-summary :news-story="story" :is-home-page="true" />
                  </li>
                </ul>
                <p v-if="newStoriesAreLoading === true">
                  <loading-spinner />
                </p>
                <p v-if="newStoriesAreLoading === false && (IsNullOrUndefined(newsStories, 'length') || newsStories.length < 1)">
                  No recent news. Please check back later.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <recent-activity />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios                        from "axios";
  import { mapGetters }               from "vuex";
  import moment                       from "moment";
  import { NewsService,
           ErrorLogService,
           CarouselService }          from "@/services/";
  import { LoadingSpinner,
           Carousel,
           NewsSummary,
           RecentActivity }            from "@/components";
  import { brandAndRegionAuthHelper } from "@/components/mixins"
  import { BrandAuthorization } from '@/types';

  export default {
    components: {
      LoadingSpinner,
      NewsSummary,
      Carousel,
      RecentActivity
    },
    mixins: [brandAndRegionAuthHelper],
    props: {
      theme: {
        type: String,
        default: "Default"
      }
    },
    data: () => ({
      msg: "Welcome to " + process.env,
      apiMsg: "",
      newsStories: {},
      newStoriesAreLoading: true,
      carouselAds: {},
      carouselAdsAreLoading: true
    }),
    computed: {
      ...mapGetters(["getContentItem", "isPriceVisible", "user"])
    },
    created () {
      axios.get(window.appGlobals.API_URL + "home").then(response => {
        this.apiMsg = response.data
      });
    },
    mounted () {
      this.getHomepageNewsStories();
      this.getActiveCarouselAds();
    },
    methods: {
      async getHomepageNewsStories() {
        try {
          this.newStoriesAreLoading = true;
          let result = await NewsService.getHomePageNewsStories();
          result = result.filter(ns =>
            this.IsBrandRegionAuthorized(ns.BrandAuthorization, ns.Region)
            );
          this.newsStories = result.slice(0,5);
        } catch (err) {
          ErrorLogService.LogAndGetErrorMessage(err);
        } finally {
          this.newStoriesAreLoading = false;
        }
      },
      async getActiveCarouselAds() {
        try {
          this.carouselAdsAreLoading = true;
          let result = await CarouselService.getActiveCarouselAds();

          result.data = result.data.filter(c =>
            this.IsBrandRegionAuthorized(c.BrandAuthorization, c.Region)
            );
          this.carouselAds = result.data;
        } catch (err) {
          ErrorLogService.LogAndGetErrorMessage(err);
        } finally {
          this.carouselAdsAreLoading = false;
        }
      },


    },
  }
</script>

<style lang="scss">
.all-news-link-wrapper{
  position: relative;
}
.all-news-link{
  position: absolute;
  bottom: 5px;
  right: 15px;
}

.news-home ul {
  list-style-type: none;
  margin: 0;
  padding-left: 2px;
}

.news-home ul li {
  border-bottom: 1px solid $lightest-gray;
  padding-top: 6px;
}

.news-home p.details {
  margin-top: 0;
  color: #666;
}
</style>
